"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanLocalStorage = void 0;
const lodash_range_1 = __importDefault(require("lodash.range"));
/**
 * Removes keys from localStorage based on the provided pattern. This can be used
 * to clean up data leftover from previous versions when using the LocalStore.
 *
 * @param keyPattern - A RegExp to filter the keys on. For example, new RegExp(`^${packageName}:`)
 * @param exclude - An array of keys that shouldn't be removed, even if they match the provided pattern.
 *                  This can be set to the LocalStores active cacheKey.
 */
function cleanLocalStorage(keyPattern, exclude) {
    try {
        const keysToRemove = (0, lodash_range_1.default)(0, localStorage.length)
            .map((i) => localStorage.key(i))
            .filter((key) => !!key)
            .filter((key) => keyPattern.test(key) && !exclude.includes(key));
        for (const key of keysToRemove) {
            console.log(`Removing localStorage item "${key}"`);
            localStorage.removeItem(key);
        }
    }
    catch (error) {
        console.warn(error);
    }
}
exports.cleanLocalStorage = cleanLocalStorage;
